import { useTranslation } from 'react-i18next';

interface AccessBlockedProps {
  message?: string;
  resourceName?: string;
}

const formatResourceDisplayName = (name: string) =>
  name.charAt(0).toUpperCase() + name.slice(1).replace(/_/g, ' ');

export const AccessBlocked = ({ message, resourceName }: AccessBlockedProps) => {
  const { t } = useTranslation();
  const displayMessage =
    message ||
    (resourceName
      ? t('You do not have access to {{resourceName}}.', {
          resourceName: formatResourceDisplayName(resourceName),
        })
      : t('You do not have access to this tab.'));

  return (
    <div className="flex-1 flex items-center justify-center h-full border-2 border-danger rounded-lg m-4 bg-danger/10">
      <div className="text-2xl text-danger">{displayMessage}</div>
    </div>
  );
};
